// extracted by mini-css-extract-plugin
export var blue = "_25-h";
export var brand = "_25-d";
export var darkGrey = "_25-g";
export var disabled = "_25-6";
export var disabledSubtle = "_25-7";
export var error = "_25-8";
export var green = "_25-i";
export var grey = "_25-f";
export var icon = "_25-0";
export var inherit = "_25-c";
export var lightGrey = "_25-e";
export var orange = "_25-k";
export var pink = "_25-m";
export var primary = "_25-1";
export var purple = "_25-n";
export var quaternary = "_25-4";
export var quinary = "_25-5";
export var red = "_25-l";
export var secondary = "_25-2";
export var success = "_25-b";
export var tertiary = "_25-3";
export var warning = "_25-9";
export var warningSecondary = "_25-a";
export var white = "_25-o";
export var yellow = "_25-j";